import { Check } from 'components/Icons/Icons';
import React from 'react';
import './MintSuccessfulModal.scss';

type Props = {
  onClick: () => void;
  eggId: number;
  mintsLeft: number;
};

export const MintSuccessfulModal = ({ onClick, eggId, mintsLeft }: Props) => {
  return (
    <div className="modal mint-successful-modal show fade" tabIndex={-1} role="dialog">
      <div className="modal-backdrop fade show" onClick={onClick}></div>
      <div className="modal-dialog mint-successful-modal-dialog">
        <div className="modal-content">
          <div className="modal-body mint-successful">
            <div className="mint-successful-egg">
              <video src="/egg_assets/base_egg_lv1st1.mp4" autoPlay muted controls={false} loop />
              <h4>Egg #{eggId}</h4>
            </div>
            <div className="mint-successful-message">
              <div className="mint-check-wrapper">
                <Check />
              </div>
              <h3>Minting Successful</h3>
              <button className="btn btn-primary btn-sm mint-successful-continue" onClick={onClick}>
                Continue
              </button>
              <p>Mints left: {mintsLeft}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
